import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

const config = {
  FORBID_TAGS: ['style'],
  FORBID_ATTR: ['style'],
  ADD_ATTR: ['target'],
};

const HTMLString = ({ as: Tag = 'div', html = '', ...props }) => (
  <Tag
    {...props}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, config) }}
  />
);
HTMLString.displayName = 'HtmlString';
HTMLString.propTypes = {};
HTMLString.defaultProps = {};

export default HTMLString;
